
import { Capacitor } from '@capacitor/core';
import { PushNotifications, PushNotificationSchema, DeliveredNotifications } from '@capacitor/push-notifications';
import { LocalStorage } from '../../services/Utils/LocalStorage';

export class PushService {
  static GoToRoomId: string | null = null;
  // Override this.
  static onNotificationReceived = (notif: PushNotificationSchema) => { console.log('Received notification', notif) };
  static currentFCMToken?: string;

  static async init() {
    // console.log('platforms: ', getPlatforms());
    if (Capacitor.isNativePlatform()) {
      try {
        console.log('PushService init start');
        await this.addPushListeners();
        await this.registerNotifications();
        await this.getDeliveredNotifications();
        console.log('PushService init done');
      } catch (error) {
        console.warn('PushService init error (non-fatal):', error);
      }
    } else if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      // PWA (Standalone 모드)에서만 토큰 모니터링
      console.debug('PushService init for PWA');
      this.startPWATokenMonitoring();
    } else {
      // 일반 웹 브라우저: 토큰 모니터링하지 않음 (불필요한 토큰 누적 방지)
      console.debug('PushService: Skipping init for regular browser (non-PWA)');
    }
  }

  static onTokenRefreshCallback: ((token: string) => void) | null = null;

  static async startPWATokenMonitoring() {
    const mod = await import('../../pwa-push');
    mod.initForegroundMessageListener((payload: any) => {
      console.log('[PushService] Foreground message received:', payload);
    });

    const check = async () => {
      const token = await mod.getFCMToken();
      if (token && token !== this.currentFCMToken) {
        console.log('[PushService] FCM Token Refreshed/Changed', token);
        this.currentFCMToken = token;
        if (this.onTokenRefreshCallback) this.onTokenRefreshCallback(token);
      }
    };

    // Check on init
    await check();

    // Check periodically (every 1 hour)
    setInterval(check, 60 * 60 * 1000);

    // Check on visibility change (app foreground)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
  }

  static addPushListeners = async () => {
    await PushNotifications.addListener('registration', token => {
      console.log('Registration token: ', token.value);
      this.currentFCMToken = token.value;
      // 토큰 콜백 호출 (네이티브 앱용)
      if (this.onTokenRefreshCallback) {
        this.onTokenRefreshCallback(token.value);
      }
    });

    await PushNotifications.addListener('registrationError', err => {
      console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
      console.log('Push notification received: ', notification);
      this.onNotificationReceived(notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', action => {
      console.log('pushNotificationActionPerformed1', action.actionId, action.notification?.data?.roomId ?? null);
      if (action.notification.data) {
        this.GoToRoomId = action.notification?.data?.roomId ?? null;
        LocalStorage.set("last-push-room", action.notification?.data?.roomId)
      }
    });
  }

  static registerNotifications = async () => {
    try {
      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted') {
        console.log('PushService: User denied push notification permissions');
        return; // 권한 거부 시 조용히 종료
      }

      console.log('PushService.registerNotifications: permission status:', permStatus);
      await PushNotifications.register();
    } catch (error) {
      console.warn('PushService.registerNotifications error:', error);
      // 에러 발생 시 앱이 계속 동작하도록 조용히 처리
    }
  }

  static getDeliveredNotifications = async (): Promise<DeliveredNotifications> => {
    const notifications = await PushNotifications.getDeliveredNotifications();
    console.log('delivered notifications', notifications);
    return notifications;
  }

  static removeAllDeliveredNotifications = async () => {
    await PushNotifications.removeAllDeliveredNotifications();
  }

  static removeNotificationsByRoomId = async (roomId: string) => {
    this.getDeliveredNotifications().then(async notifications => {
      console.log("removeNotificationsByRoomId1", roomId, notifications.notifications);
      notifications.notifications.forEach(async notification => {
        console.log("removeNotificationsByRoomId2", notification.tag, notification.data?.roomId);
        if (notification.data?.roomId === roomId || notification.tag === roomId) {
          console.log("removeNotificationsByRoomId3", roomId, notification);
          await PushNotifications.removeDeliveredNotifications({ notifications: [notification] });
        }
      });
    });
  }

}